const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		mid: null,
		user: {},
		classList: [],
		emptyFlag: false,
	},
	methods: {
		getParams() {
			this.mid = this.getQueryString('mid') || 11;
		},
		getInfo() {
			axios.post(baseURL + 'checkCookies')
				.then(res => {
					if (res.code == 200) {
						this.user = res.list;
					}
					if (res.code == -1) {
						this.goLogin();
					}
				})
				.catch(err => console.log(err));
		},
		// 获取课程
		getClass() {
			axios.post(baseURL + 'getMygrade?mid=' + this.mid)
				.then(res => {
					if (res.code == 200) {
						this.classList = res.list;
						if (res.list.length == 0) {
							this.emptyFlag = true;
						}
					}
				})
				.catch(err => console.log(err));
		},
		// 切换专业
		changeMajor(mid) {
			if (mid == this.mid) {
				return
			}
			location.href = 'pages/user/class.html?mid=' + mid;
		},
		// 跳转详情
		goClassDetail(item, format) {
			location.href = 'pages/class/detail.html?format=' + format + '&type=3&id=' + item.gid + '&mid=' + this.mid;
		}
	},
	created() {
		this.getParams();
		this.getInfo();
		this.getClass();
	}
});